// Generated from SVG to Code Figma Plugin

export const AgentLineQuote = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.42543 4.55769C5.66013 6.9758 3.56834 9.7903 3.15006 13.0012C2.49888 17.9997 6.96898 20.4464 9.23393 18.2481C11.4989 16.0498 10.1412 13.2595 8.50113 12.4968C6.86108 11.7341 5.85813 11.9997 6.03308 10.9805C6.20803 9.96125 8.54133 7.13535 10.5912 5.8193C10.7272 5.70365 10.779 5.47925 10.648 5.309C10.5619 5.19705 10.3929 4.97748 10.1412 4.65026C9.92103 4.36413 9.71013 4.37484 9.42543 4.55769Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      d="M19.3375 4.55818C15.5723 6.97629 13.4805 9.79079 13.0622 13.0016C12.411 18.0002 16.8811 20.4468 19.1461 18.2485C21.411 16.0502 20.0533 13.26 18.4133 12.4973C16.7732 11.7345 15.7702 12.0002 15.9452 10.9809C16.1202 9.96174 18.4535 7.13584 20.5034 5.81979C20.6394 5.70414 20.6911 5.47974 20.5601 5.30949C20.474 5.19754 20.3051 4.97797 20.0533 4.65075C19.8332 4.36462 19.6223 4.37533 19.3375 4.55818Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
